/* Animate On Scroll — dependency-free runtime for the [data-aos] states in
   landing-critical.css. Adds .aos-animate when an element enters the viewport.

   Attributes read from the element:
     data-aos            animation name (fade-up, fade-left, zoom-in, ...)
     data-aos-delay      milliseconds
     data-aos-duration   milliseconds (overrides the CSS default)
     data-aos-once       "false" to re-animate on every entry (default: once) */
(function () {
  var SELECTOR = '[data-aos]';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) {
    el.classList.add('aos-animate');
  }

  function prime(el) {
    var duration = el.getAttribute('data-aos-duration');
    var delay = el.getAttribute('data-aos-delay');
    if (duration) el.style.transitionDuration = parseInt(duration, 10) / 1000 + 's';
    if (delay) el.style.transitionDelay = parseInt(delay, 10) / 1000 + 's';
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll(SELECTOR);
    if (!els.length) return;

    // No motion preference, or no observer: show everything at once.
    if (reduced || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) reveal(els[i]);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          var el = entry.target;
          if (entry.isIntersecting) {
            reveal(el);
            if (el.getAttribute('data-aos-once') !== 'false') obs.unobserve(el);
          } else if (el.getAttribute('data-aos-once') === 'false') {
            el.classList.remove('aos-animate');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
    );

    for (var j = 0; j < els.length; j++) {
      if (els[j].dataset.aosInit === 'true') continue;
      els[j].dataset.aosInit = 'true';
      prime(els[j]);
      observer.observe(els[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Sections re-rendered by the theme editor need a fresh scan.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
